/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import _ from "lodash";
import { GET_ALL_CUSTOMERS, SET_NO_CUSTOMER, SET_SELECTED_CUSTOMER, REMOVE_CUSTOMER } from "./types";

const initialState = {
  customers: [],
  noCustomer: false,
  selectedCustomer: {},
  pagination: {
    pageNumber: 1,
    pageSize: 50,
    totalCount: 50,
  }
};

export const customerReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_ALL_CUSTOMERS:
      return {
        ...state,
        customers: action.customers,
        noCustomer: action.noCustomer,
        selectedCustomer: action.selectedCustomer,
        pagination: {
          ...action.pagination
        }
      };
    case SET_SELECTED_CUSTOMER:
      return {
        ...state,
        selectedCustomer: action.selectedCustomer,
      };
    case SET_NO_CUSTOMER:
      return {
        ...state,
        noCustomer: action.noCustomer,
      };
    case REMOVE_CUSTOMER:
      const customers = state.customers.filter((customer: any) => customer.id !== action.id);
      return {
        ...state,
        customers: customers,
      };
    default:
      return state;
  }
};
